import React from 'react';

// helpers
import {useScreenWidth} from '../../../../shared/hooks';
import {useTheme} from '@emotion/react';
import {useTranslation} from 'react-i18next';

// components
import {CardBorder, TableLoans} from '../../../../shared/components';
import {CardLoan} from './components';

// styles
import {Subtitle, TextColors} from '../../../../shared/styles';
import {
  SectionLoansDesktopWrapper,
  SectionLoansMobileWrapper,
} from './SectionLoans-styles';

// types
import {Loan} from '../../../../shared/services/ApiService/types';

type Props = {
  loans: Loan[];
};

const SectionLoans = ({loans}: Props) => {
  const {t} = useTranslation();
  const screenWidth = useScreenWidth();
  const theme = useTheme();

  if (screenWidth < theme.screenBreakpoint.md.value) {
    return (
      <SectionLoansMobileWrapper>
        <Subtitle bold="bold" color={TextColors.secondary}>
          {t('loan_loans')}
        </Subtitle>
        {loans.map((loan) => (
          <CardLoan key={loan.id} loan={loan} />
        ))}
      </SectionLoansMobileWrapper>
    );
  }

  return (
    <CardBorder variant="white">
      <SectionLoansDesktopWrapper>
        <Subtitle bold="bold">{t('loan_loans')}</Subtitle>
        <TableLoans loans={loans} />
      </SectionLoansDesktopWrapper>
    </CardBorder>
  );
};

export default SectionLoans;
